var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyValue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274 390c23 0 34 0 42-4 3-1 6-4 9-6 2-3 5-6 6-9l1-1c1-3 2-7 3-13v-26h16v27c-1 8-2 14-5 19v1c-3 5-6 9-10 13s-8 7-13 10c-11 5-24 5-49 5H77c-25 0-38 0-49-5-5-3-9-6-13-10s-7-8-9-13l-1-1c-2-5-4-11-4-19-1-7-1-17-1-29V171c0-25 0-38 6-49 2-5 5-9 9-13s8-7 13-10l9-3v17s-1 0-2 1c-3 1-6 4-9 6l-6 9c-4 8-4 19-4 42v158c0 12 0 21 1 28 0 6 1 10 3 13v1l6 9c3 2 6 5 9 6 8 4 19 4 42 4h197z M330 297c23 0 34 0 42-4 3-2 6-4 9-7 3-2 5-5 6-9h1c1-4 2-8 3-14V77c0-23 0-34-4-42-1-3-3-6-6-9l-9-6c-8-4-19-4-42-4H134c-23 0-35 0-42 4-4 2-7 4-9 6-3 3-5 6-7 9-4 8-4 19-4 42v158c0 12 0 21 1 28 0 6 1 10 3 14s4 7 7 9c2 3 5 5 9 7 7 4 19 4 42 4h196zm-196 16c-26 0-39 0-50-6-5-2-9-5-13-9s-7-9-9-13l-1-1c-2-6-4-12-4-20-1-7-1-16-1-29V77c0-25 0-38 6-49 2-5 5-9 9-13s8-7 13-9c11-6 24-6 50-6h196c26 0 38 0 49 6 5 2 10 5 13 9 4 4 7 8 10 13 5 11 5 24 5 49v187c-1 8-2 14-5 20v1c-3 4-6 9-10 13s-8 7-13 9c-11 6-23 6-49 6H134z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyValue);
export default __webpack_public_path__ + "static/media/CopyValue.183d8858b85a1a05cf85a1661b422904.svg";
export { ForwardRef as ReactComponent };